import { adminAuthApi } from './admin/api'
import { api, authApi } from './api'

// GET: 알림 가져오기 by userId
export const getNotificationApi = (userId) => authApi.get(`/notification/${userId}`)
export const adminGetNotificationApi = (userId) => adminAuthApi.get(`/notification/${userId}`)

// PUT: 알림 읽음 처리
export const readNotificationApi = (data) => authApi.put(`/notification/read`, data)
export const adminReadNotificationApi = (data) => adminAuthApi.put(`/notification/read`, data)
